import request from "@/axios";
/** 分页查询媒资订单的接口 */
export const getList = params => {
  return request({
    url: "/lebo-vod/vod/payOrder/page",
    method: "get",
    params
  });
};
/** 获取媒资来源下拉列表的数据 */
export const getMediaSource = () => {
  return request({
    url: `/lebo-vod/vod/partner/list`,
    method: "get"
  });
};
/** 申请退款的接口 */
export const refund = data => {
  return request({
    url: `/lebo-vod/vod/refundOrder/save`,
    method: "post",
    data
  });
};
/** 媒资订单导出的接口 */
export const exportExcel = params => {
  return request({
    url: `/lebo-vod/vod/payOrder/exportExcel`,
    method: "get",
    params,
    responseType: "blob"
  });
};
